// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"jW","productsContainer":"kW","searchVerticalReco":"lW","heading":"mW"};